// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 990px) {
  .container-datepicker {
    float: left;
    width: 100%;
    margin: -75px 7.5px 15px 7.5px;
  }
  .container-datepicker app-datepicker {
    margin: 20px 0 20px 0;
    float: right;
  }
}
@media only screen and (max-width: 991px) {
  .container-datepicker {
    float: left;
    width: 100%;
    margin: 15px 7.5px 15px 7.5px;
  }
  .container-datepicker app-datepicker {
    margin: 20px 0 20px 0;
    float: right;
  }
}
@media only screen and (max-width: 515px) {
  .container-datepicker {
    margin: 0;
    padding: 0 7.5px;
  }
  app-datepicker {
    width: 100%;
  }
}
.caixa-pesquisa {
  cursor: text;
}
.caixa-pesquisa div input {
  position: absolute;
  left: 55px;
  width: 300px;
  max-width: calc(100% - 75px);
  outline: none;
  border: 0px;
  height: 40px;
}
.caixa-pesquisa input.search {
  position: relative;
  border-radius: 6px;
  height: 40px;
  width: 100%;
  margin: 0 0 20px 0;
  border: none;
  padding: 5px 50px;
  outline: none;
  transition: border-color 0.5s ease;
  box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);
}
.caixa-pesquisa input.search:active, .caixa-pesquisa input.search:hover, .caixa-pesquisa input.search:focus {
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.16);
}
.caixa-pesquisa::after, .caixa-pesquisa::before {
  content: " ";
  position: absolute;
  display: inline-block;
  width: 24px;
  height: 24px;
  top: 8px;
}
.caixa-pesquisa::before {
  left: 20px;
  background-image: url("/assets/img/icons/pesquisa.svg");
}
.caixa-pesquisa::after {
  right: 20px;
  cursor: pointer;
}
.caixa-pesquisa .filter-icon {
  position: absolute;
  top: 0;
  right: 12px;
  height: 40px;
  width: 40px;
  cursor: pointer;
  z-index: 5;
}
.caixa-pesquisa .box-filter {
  z-index: 5;
  position: absolute;
  width: 250px;
  top: 0;
  right: -245px;
  background-color: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);
  overflow: hidden;
}
.caixa-pesquisa .box-filter.box-hidden {
  transition: 0.4s;
  opacity: 0;
  z-index: -1;
}
.caixa-pesquisa .box-filter.box-show {
  transition: 0.4s;
  opacity: 1;
}
.caixa-pesquisa .box-filter .container-box-inner {
  float: left;
  width: 100%;
}
.caixa-pesquisa .box-filter .container-box-inner label {
  float: left;
}
.caixa-pesquisa .box-filter .container-box-inner label:first-child {
  width: 100%;
}
.caixa-pesquisa .box-filter .container-box-inner > div {
  margin-bottom: 2px;
  float: left;
}
.caixa-pesquisa .box-filter .container-box-inner > div label {
  margin-right: 5px;
  color: #999999;
  background: rgba(204, 204, 204, 0.2);
  padding: 5px 10px;
  border-radius: 3px;
  transition: 0.5s;
  cursor: pointer;
}
.caixa-pesquisa .box-filter .container-box-inner > div label:hover {
  background: rgba(204, 204, 204, 0.4);
  transition: 0.5s;
}
.caixa-pesquisa .box-filter .container-box-inner:last-child {
  margin-top: 15px;
}

.container-loading {
  width: 35px;
  height: 35px;
  margin: 0 auto;
}
.container-loading .loading {
  margin: 100px 0 0 0;
}

.error {
  width: 100%;
  font-size: 16px;
  font-weight: 100;
  color: #999999;
  text-align: center;
  display: inline-block;
}
.error:first-child {
  margin-top: 100px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/agenda-financeira/agenda-financeira.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AACA;EACI;IACI,WAAA;IACA,WAAA;IACA,8BAAA;EAAN;EACM;IACI,qBAAA;IACA,YAAA;EACV;AACF;AAGA;EACI;IACI,WAAA;IACA,WAAA;IACA,6BAAA;EADN;EAEM;IACI,qBAAA;IACA,YAAA;EAAV;AACF;AAIA;EACI;IACI,SAAA;IACA,gBAAA;EAFN;EAIE;IACI,WAAA;EAFN;AACF;AAKA;EACI,YAAA;AAHJ;AAKQ;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,4BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AAHZ;AAMI;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,kCAAA;EACA,iDAAA;AAJR;AAKQ;EAGI,gDAAA;AALZ;AAQI;EAEI,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;AAPR;AASI;EACI,UAAA;EACA,uDAAA;AAPR;AASI;EACI,WAAA;EACA,eAAA;AAPR;AAUI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AARR;AAUI;EACI,UAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,aAAA;EACA,sBCzEA;ED0EA,aAAA;EACA,kBAAA;EACA,iDAAA;EACA,gBAAA;AARR;AASQ;EACI,gBAAA;EACA,UAAA;EACA,WAAA;AAPZ;AASQ;EACI,gBAAA;EACA,UAAA;AAPZ;AASQ;EACI,WAAA;EACA,WAAA;AAPZ;AAQY;EACI,WAAA;AANhB;AAOgB;EACI,WAAA;AALpB;AAQY;EACI,kBAAA;EACA,WAAA;AANhB;AAOgB;EACI,iBAAA;EACA,cC5GR;ED6GQ,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AALpB;AAMoB;EACI,oCAAA;EACA,gBAAA;AAJxB;AAQY;EACI,gBAAA;AANhB;;AAYA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AATJ;AAUI;EACI,mBAAA;AARR;;AAYA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cC5IU;ED6IV,kBAAA;EACA,qBAAA;AATF;AAUE;EACE,iBAAA;AARJ","sourcesContent":["@import '../../../../../sass/variables';\n@media only screen and (min-width: 990px) {\n    .container-datepicker {\n        float: left;\n        width: 100%;\n        margin: -75px 7.5px 15px 7.5px;\n        app-datepicker {\n            margin: 20px 0 20px 0;\n            float: right;\n        }\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .container-datepicker {\n        float: left;\n        width: 100%;\n        margin: 15px 7.5px 15px 7.5px;\n        app-datepicker {\n            margin: 20px 0 20px 0;\n            float: right;\n        }\n    }\n}\n\n@media only screen and (max-width: 515px) {\n    .container-datepicker {\n        margin: 0;\n        padding: 0 7.5px;\n    }\n    app-datepicker {\n        width: 100%;\n    }\n}\n\n.caixa-pesquisa {\n    cursor: text;\n    div {\n        input {\n            position: absolute;\n            left: 55px;\n            width: 300px;\n            max-width: calc(100% - 75px);\n            outline: none;\n            border: 0px;\n            height: 40px;\n        }\n    }\n    input.search {\n        position: relative;\n        border-radius: 6px;\n        height: 40px;\n        width: 100%;\n        margin: 0 0 20px 0;\n        border: none;\n        padding: 5px 50px;\n        outline: none;\n        transition: border-color 0.5s ease;\n        box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);\n        &:active,\n        &:hover,\n        &:focus {\n            box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.16);\n        }\n    }\n    &::after,\n    &::before {\n        content: ' ';\n        position: absolute;\n        display: inline-block;\n        width: 24px;\n        height: 24px;\n        top: 8px;\n    }\n    &::before {\n        left: 20px;\n        background-image: url('/assets/img/icons/pesquisa.svg');\n    }\n    &::after {\n        right: 20px;\n        cursor: pointer;\n        // background-image: url('/assets/img/icons/filtro.svg');\n    }\n    .filter-icon {\n        position: absolute;\n        top: 0;\n        right: 12px;\n        height: 40px;\n        width: 40px;\n        cursor: pointer;\n        z-index: 5;\n    }\n    .box-filter {\n        z-index: 5;\n        position: absolute;\n        width: 250px;\n        top: 0;\n        right: -245px;\n        background-color: $white;\n        padding: 20px;\n        border-radius: 6px;\n        box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);\n        overflow: hidden;\n        &.box-hidden {\n            transition: 0.4s;\n            opacity: 0;\n            z-index: -1;\n        }\n        &.box-show {\n            transition: 0.4s;\n            opacity: 1;\n        }\n        .container-box-inner {\n            float: left;\n            width: 100%;\n            label {\n                float: left;\n                &:first-child {\n                    width: 100%;\n                }\n            }\n            >div {\n                margin-bottom: 2px;\n                float: left;\n                label {\n                    margin-right: 5px;\n                    color: $cinza-500;\n                    background: rgba($cinza-400, 0.2);\n                    padding: 5px 10px;\n                    border-radius: 3px;\n                    transition: 0.5s;\n                    cursor: pointer;\n                    &:hover {\n                        background: rgba($cinza-400, 0.4);\n                        transition: 0.5s;\n                    }\n                }\n            }\n            &:last-child {\n                margin-top: 15px;\n            }\n        }\n    }\n}\n\n.container-loading {\n    width: 35px;\n    height: 35px;\n    margin: 0 auto;\n    .loading {\n        margin: 100px 0 0 0;\n    }\n}\n\n.error {\n  width: 100%;\n  font-size: 16px;\n  font-weight: 100;\n  color: $cinza-500;\n  text-align: center;\n  display: inline-block;\n  &:first-child {\n    margin-top: 100px;\n  }\n}\n","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
